import { Configurer } from '../Core/index';
import { Messaging } from './Messaging';

/**Messaging service*/
export class MessagingConfigurer extends Configurer {}
